"use client";

import React, { useState, useMemo } from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Input } from "./ui/input";
import {
  ChevronDown,
  Search as SearchIcon,
  Wallet,
  Mail,
  Phone,
} from "lucide-react";
import addressImage from "../assets/images/settings/address_book.png";

const AccountSelectSecondary = ({
  selectedAccountFrom,
  onSelect,
  list,
  selectedAccount,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const current = list.find((item) => item._id === selectedAccountFrom?._id);
  const triggerLabel = current ? current.accountName : "Select Acc";
  const TriggerIcon = current ? current.Icon : Wallet;

  const filteredPaymentIds = useMemo(() => {
    const selectedId = selectedAccount?._id;
    return list.filter(
      (item) =>
        item?._id !== selectedId &&
        item?.accountName?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, list]);

  return (
    <div>
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogTrigger asChild>
          <div className="border rounded-lg px-4 py-4 flex items-center justify-between cursor-pointer bg-white">
            <span className="flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-gradient-to-tr from-purple-500 to-rose-500">
                {!list ? (
                  <TriggerIcon className="w-5 h-5 text-white" />
                ) : (
                  <img
                    src={addressImage}
                    alt={"addresses icon"}
                    width={56}
                    height={56}
                    quality={100}
                    className="object-cover"
                  />
                )}
              </span>
              <span className="text-sm text-gray-700 font-medium">
                {triggerLabel}
              </span>
            </span>
            <ChevronDown size={16} className="text-gray-500" />
          </div>
        </DialogTrigger>

        <DialogContent className="max-w-md rounded-lg">
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold">
              Select a payment ID
            </DialogTitle>
          </DialogHeader>
          <div className="mt-4">
            <div className="relative">
              <Input
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="mb-4 w-full rounded-full"
              />
              <SearchIcon
                size={16}
                className="absolute right-4 top-2.5 text-gray-400"
              />
            </div>

            <ul className="space-y-2 max-h-[300px] overflow-y-auto">
              {filteredPaymentIds.map((item) => (
                <li
                  key={item._id}
                  className="flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 rounded-md cursor-pointer hover:border-rose-500/50 hover:border-s"
                  onClick={() => {
                    onSelect(item);
                    setIsOpen(false);
                  }}
                >
                  <div className="flex items-center gap-2">
                    <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-tr from-purple-500 to-rose-500">
                      <img
                        src={addressImage}
                        alt={"addresses icon"}
                        width={56}
                        height={56}
                        quality={100}
                        className="object-cover"
                      />
                    </span>
                    <p className="text-sm font-medium">{item.accountName}</p>
                  </div>
                </li>
              ))}
              {filteredPaymentIds.length === 0 && (
                <li className="text-center text-sm text-gray-500">
                  No Accounts found
                </li>
              )}
            </ul>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AccountSelectSecondary;
